import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getDataCommon } from "../api/common";
import DetailSectionMultiImage from "../components/DetailSectionMultiImage";
import { toImagePath } from "../utils/globalFunctions";

const CommonPage = () => {
  const { jsonName } = useParams();

  const [pageData, setPageData] = useState(null);

  const getData = useCallback(
    () =>
      getDataCommon(`${jsonName}.json`)
        .then((res) => {
          setPageData(res);
        })
        .catch((err) => console.log(err)),
    [setPageData, jsonName]
  );

  useEffect(() => {
    getData();
  }, [getData]);

  const imagePath = pageData?.topimage[0]?.path;

  return (
    <DetailSectionMultiImage
      pageTitle={pageData?.title}
      content={pageData?.content}
      images={pageData?.topimage}
    />
  );
};

export default CommonPage;
